import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ICliente, ILayerMapaPersonalizado, IQueryParam } from 'modelos/src';
import { IntegracionesService } from '../../../../../auxiliares/servicios/http/integraciones.service';
import { ISirena } from 'modelosSeguridad/src';
import { TipoMapaBase } from '../../../../standalone/selector-tipo-mapa/selector-tipo-mapa.component';
import { LoginService } from '../../../../login/login.service';
import { MapaFacilV2Service } from '../../../../../auxiliares/mapbox/mapa-facil-v2.service';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { Subscription } from 'rxjs';
import mapboxgl from 'mapbox-gl';
import {
  ISirenaExtendida,
  EstadoSirena,
} from '../../../../../auxiliares/mapbox/entity-managers/sirenas-layer.manager';

@Component({
  selector: 'app-mapa-sirenas',
  templateUrl: './mapa-sirenas.component.html',
  styleUrl: './mapa-sirenas.component.scss',
  standalone: false,
})
export class MapaSirenasComponent implements OnInit, OnDestroy {
  private lista2 = inject(Lista2Service);
  private service = inject(IntegracionesService);
  private mapaFacilV2Service = inject(MapaFacilV2Service);

  public ctrl = false;

  //sirenas
  private sirenas$?: Subscription;
  public sirena?: ISirena;
  public sirenas?: ISirena[] = [];
  public sirenasOnline?: number = 0;
  public sirenasOffline?: number = 0;

  private querySirenas: IQueryParam = {};

  //Nombre del mapa
  public nombreMap = 'MapaSirenasComponent';

  // Entidades permitidas para re-aplicar datos al cambiar capa base. Las entidades pueden ser las que están presentes en MapaFacilV2Data
  public allowedTypes: string[] = ['sirenas'];

  //MAPAS A MOSTRAR
  public readonly TIPO_MAPA_BASE_KEY = 'tipoMapaBaseSirenasComponent';
  public tipoMapaBase: TipoMapaBase =
    localStorage.getItem(this.TIPO_MAPA_BASE_KEY) || 'osm';
  public mapasPersonalizados: ILayerMapaPersonalizado[] = [];
  public clientePropio: ICliente = LoginService.getClientePropio();

  /// Cluster de sirenas
  public mostrarClusters = true;

  //Propiedades para zoom
  public currentZoom = 16;

  // Mapa
  public map: mapboxgl.Map | null = null;

  /// sirenas
  public async listar(): Promise<void> {
    this.sirenas$ = this.lista2.sirenas(this.querySirenas).subscribe((data) => {
      this.sirenas = data?.datos || [];
      this.sirenas?.forEach((s) => {
        if (s.online) {
          this.sirenasOnline++;
        } else {
          this.sirenasOffline++;
        }
      });
      this.addSirenas();
    });
  }

  private addSirenas() {
    if (!this.mapaFacilV2Service.isReady()) return;

    const sirenas: ISirenaExtendida[] = [];
    for (const s of this.sirenas) {
      if (!s.geojson?.coordinates) {
        console.warn('⚠️ Sirena sin geojson.coordinates:', s._id, s);
        continue;
      }

      const sirenaExtendida: ISirenaExtendida = {
        // Propiedades requeridas
        _id: s._id,
        idCliente: s.idCliente,
        coordenadas: [s.geojson.coordinates[0], s.geojson.coordinates[1]],

        // Pasar toda la data de la sirena para determinación automática de estado y popup
        ...s,
      };

      sirenas.push(sirenaExtendida);
    }
    this.mapaFacilV2Service.updateData({ sirenas });
  }

  public estadoSirena(sirena: ISirena): string {
    if (sirena.online) {
      if (sirena.sonidoEncendido && sirena.luzEncendida) {
        return 'Online - Sirena y Reflector Encendidos';
      }
      if (sirena.sonidoEncendido) {
        return 'Online - Sirena Encendida';
      }
      if (sirena.luzEncendida) {
        return 'Online - Reflector Encendido';
      }
      return 'Online - Apagada';
    } else {
      return 'Offline';
    }
  }

  public onClusterToggle(clusterizar: boolean) {
    this.mostrarClusters = clusterizar;
    this.mapaFacilV2Service.setClusteringEnabled(
      'sirenas',
      this.mostrarClusters,
    );
  }

  // Mapa - Métodos migrados a MapaFacilV2

  public onMapReady(map: mapboxgl.Map) {
    this.map = map;

    // Configurar clustering inicial
    this.mapaFacilV2Service.setClusteringEnabled(
      'sirenas',
      this.mostrarClusters,
    );

    // Actualizar datos si ya se listaron
    if (this.sirenas && this.sirenas.length > 0) {
      this.addSirenas();
    }
  }

  ///
  async ngOnInit() {
    if (this.clientePropio?.mapLayers) {
      this.mapasPersonalizados = this.clientePropio.mapLayers;
    }
    await this.listar();
  }

  ngOnDestroy() {
    this.sirenas$?.unsubscribe();

    // IMPORTANTE: Limpiar datos del servicio para evitar que persistan al cambiar de mapa
    // El servicio es singleton, por lo que mantiene datos entre componentes
    this.mapaFacilV2Service.clearAllData();
  }
}
